{
  "titles": {
    "appointmentDetailsHaveChanged": "Chi tiết cuộc hẹn đã thay đổi",
    "appointmentScheduled": "Cuộc hẹn đã được lên lịch",
    "appointmentConfirmed": "Cuộc hẹn đã được xác nhận",
    "appointmentRequested": "Đã yêu cầu cuộc hẹn",
    "missedAppointment": "Lỡ cuộc hẹn",
    "recurringAppointmentSeriesCreated": "Đã tạo chuỗi cuộc hẹn định kỳ",
    "truckArrivedAtFacility": "Xe tải đã đến cơ sở",
    "appointmentIsInProgressAtFacility": "Cuộc hẹn đang được xử lý tại cơ sở",
    "appointmentRescheduled": "Cuộc hẹn đã được đổi lịch",
    "appointmentCompleted": "Cuộc hẹn đã hoàn tất",
    "appointmentCancelled": "Cuộc hẹn đã bị hủy",
    "appointmentTagged": "Cuộc hẹn đã được gắn thẻ",
    "assetReadyForPickup": "Tài sản sẵn sàng để lấy"
  },
  "subjects": {
    "appointmentDetailsHaveChanged": "Chi tiết cuộc hẹn đã thay đổi",
    "appointmentScheduled": "Cuộc hẹn đã được lên lịch tại {orgName} - {warehouseName}",
    "appointmentConfirmed": "Cuộc hẹn đã được xác nhận tại {orgName} - {warehouseName}",
    "appointmentRequested": "Đã yêu cầu cuộc hẹn tại {orgName} - {warehouseName}",
    "missedAppointment": "Lỡ cuộc hẹn tại {orgName} - {warehouseName}",
    "recurringAppointmentSeriesCreated": "Chuỗi cuộc hẹn định kỳ đã được tạo",
    "truckArrivedAtFacility": "Xe tải đã đến {orgName} - {warehouseName}",
    "appointmentIsInProgressAtFacility": "Cuộc hẹn đang được xử lý tại {orgName} - {warehouseName}",
    "appointmentRescheduled": "Cuộc hẹn đã được đổi lịch tại {orgName} - {warehouseName}",
    "appointmentCompleted": "Cuộc hẹn đã hoàn tất tại {orgName} - {warehouseName}",
    "appointmentCancelled": "Cuộc hẹn với {orgName} - {warehouseName} đã bị hủy",
    "appointmentTagged": "Cuộc hẹn được gắn thẻ {tagName} - {warehouseName}",
    "assetReadyForPickup": "Sẵn sàng để lấy - Container {containerNumber}"
  },
  "subTitles": {
    "appointmentDetailsHaveChanged": "Vui lòng kiểm tra địa điểm, ngày, giờ và tất cả chi tiết bên dưới.",
    "appointmentScheduled": "Vui lòng kiểm tra địa điểm, ngày, giờ và tất cả chi tiết bên dưới.",
    "appointmentConfirmed": "Vui lòng kiểm tra địa điểm, ngày, giờ và tất cả chi tiết bên dưới.",
    "appointmentRequested": "Vui lòng chờ kho hàng xác nhận.",
    "missedAppointment": "Hãng vận chuyển đã không đến theo cuộc hẹn.",
    "recurringAppointmentSeriesCreated": "Vui lòng kiểm tra chi tiết cuộc hẹn định kỳ bên dưới.",
    "truckArrivedAtFacility": "Kiểm tra trạng thái và chi tiết cuộc hẹn bên dưới.",
    "appointmentIsInProgressAtFacility": "Kiểm tra trạng thái và chi tiết cuộc hẹn bên dưới.",
    "appointmentRescheduled": "Kiểm tra trạng thái và chi tiết cuộc hẹn bên dưới.",
    "appointmentCompleted": "Kiểm tra trạng thái và chi tiết cuộc hẹn bên dưới.",
    "appointmentCancelled": "Vui lòng kiểm tra tất cả chi tiết và lý do hủy.",
    "appointmentTagged": "Vui lòng kiểm tra tên thẻ và thông tin bên dưới.",
    "assetReadyForPickup": "Một tài sản tại cơ sở của bạn đã sẵn sàng để lấy."
  },
  "anchorLabels": {
    "appointmentDetailsHaveChanged": "Xem cuộc hẹn",
    "appointmentScheduled": "Xem cuộc hẹn",
    "appointmentConfirmed": "Xem cuộc hẹn",
    "appointmentRequested": "Xem cuộc hẹn",
    "missedAppointment": "Xem cuộc hẹn",
    "recurringAppointmentSeriesCreated": "Xem cuộc hẹn gốc",
    "truckArrivedAtFacility": "Xem cuộc hẹn",
    "appointmentIsInProgressAtFacility": "Xem cuộc hẹn",
    "appointmentRescheduled": "Xem cuộc hẹn",
    "appointmentCompleted": "Xem cuộc hẹn",
    "appointmentCancelled": "Xem cuộc hẹn",
    "appointmentTagged": "Xem cuộc hẹn",
    "assetReadyForPickup": "Xem cuộc hẹn"
  },
  "descriptions": {
    "appointmentTagged": "Sử dụng cài đặt Thẻ cuộc hẹn để bật từng thẻ riêng lẻ"
  },
  "contextLabels": {
    "assetReadyForPickup": {
      "schedulingAnchorLabel": "Đặt lịch lấy hàng",
      "idLabel": "Số xác nhận",
      "ownedByLabel": "Thuộc sở hữu của:",
      "pickupScheduledForLabel": "Lịch lấy hàng vào:",
      "noPickupScheduledLabel": "Chưa có cuộc hẹn lấy hàng",
      "storeLabel": "Cửa hàng",
      "openInGoogleMapsLabel": "Mở trong Google Maps",
      "appointmentDetailsLabel": "Chi tiết cuộc hẹn",
      "loadTypeLabel": "Loại hàng",
      "warehouseInstructionsLabel": "Hướng dẫn của kho hàng",
      "amenitiesLabel": "Tiện ích có sẵn",
      "ppeRequirementsLabel": "PPE & các yêu cầu khác",
      "dockDoorLabel": "Cửa kho",
      "dockInstructionsLabel": "Hướng dẫn cửa kho",
      "carrierContactLabel": "Liên hệ hãng vận chuyển"
    }
  }
}
